import { displayToast } from '../../../../helpers/notification';
import { FeaturedContentTypes as Type } from '../../../types/featuredcontent';

export function getFeaturedContentListRequest() {
  return {
    type: Type.GET_FEATURED_CONTENT_LIST_REQUEST,
  };
}

export function getFeaturedContentListRequestSuccess(data: any) {
  return {
    type: Type.GET_FEATURED_CONTENT_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getFeaturedContentListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_FEATURED_CONTENT_LIST_REQUEST_FAILURE,
    error: error,
  };
}
